<template>
  <div class="what-youll-lose">
    <h2 class="h3 mb-2"><b>{{ $t('purchases.what_youll_lose.here_s_what_you_ll_lose') }}</b></h2>
    <p class="text-muted mb-4">{{ $t('purchases.what_youll_lose.cancelling_removes_the_following_from_your') }}</p>

    <div class="card what-youll-lose__callout mb-4">
      <div class="card-body d-flex align-items-center gap-3">
        <span class="material-icons what-youll-lose__callout-icon">bolt</span>
        <p class="mb-0">
          <b>{{ $t('purchases.what_youll_lose.did_you_know') }}</b>
          <i18n-t keypath="purchases.what_youll_lose.hikers_with_pro_were_more_likely" scope="global">
            <template #times><i>{{ $t('purchases.what_youll_lose.3_times') }}</i></template>
          </i18n-t>
        </p>
      </div>
    </div>

    <div v-for="feature in features" :key="feature.title" class="d-flex align-items-start gap-3 mb-3">
      <span class="material-icons what-youll-lose__feature-icon">{{ feature.icon }}</span>
      <div>
        <p class="mb-0"><b>{{ feature.title }}</b></p>
        <p class="text-muted mb-0">{{ feature.subtitle }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { i18n } from "../../../../i18n";

const t = (key: string): string => i18n.global.t(key);

const features = [
  {
    icon: "map",
    get title() { return t("purchases.what_youll_lose.premium_and_3d_maps"); },
    get subtitle() { return t("purchases.what_youll_lose.trusted_national_and_independent_maps"); },
  },
  {
    icon: "cloud",
    get title() { return t("purchases.what_youll_lose.weather_maps"); },
    get subtitle() { return t("purchases.what_youll_lose.check_the_conditions_before_you_leave"); },
  },
  {
    icon: "print",
    get title() { return t("purchases.what_youll_lose.print_maps"); },
    get subtitle() { return t("purchases.what_youll_lose.print_pro_maps_never_without_guide"); },
  },
  {
    icon: "share_location",
    get title() { return t("shared.live_locator"); },
    get subtitle() { return t("purchases.what_youll_lose.share_your_live_location"); },
  },
  {
    icon: "notifications_active",
    get title() { return t("purchases.what_youll_lose.off_route_notifications"); },
    get subtitle() { return t("purchases.what_youll_lose.get_notified_if_you_stray"); },
  },
];
</script>

<style scoped lang="scss">
.what-youll-lose {
  &__callout {
    border-radius: 12px;
    background-color: rgba(255, 215, 0, 0.12);
    border-color: rgba(255, 215, 0, 0.4);
  }

  &__callout-icon {
    color: var(--yellow, #ffd700);
  }

  &__feature-icon {
    color: var(--text-muted, #b2b2b2);
  }
}
</style>
